import { BankStages } from '../../models/Bank';
import { createSlice } from '../wrappers';

export enum OverlayType {
	Transfer = 'transfer',
	Taxes = 'taxes',
}

interface IBankState {
	activeBankState: BankStages;
	overlayVisible: boolean;
	overlayType: OverlayType;
	overlayTransferData: {
		amount: number;
		player: string;
		date: number;
	};
	overlayTaxesData: {
		amount: number;
		apartment: string;
		date: number;
	};
}

const initialState: IBankState = {
	activeBankState: BankStages.MAIN,
	overlayVisible: false,
	overlayType: OverlayType.Transfer,
	overlayTransferData: {
		amount: 0,
		player: '',
		date: 0,
	},
	overlayTaxesData: {
		amount: 0,
		apartment: '',
		date: 0,
	},
};

const bankSlice = createSlice({
	name: 'bank',
	initialState,
	reducers: {
		setActiveBankState: (state, action) => {
			state.activeBankState = action.payload;
		},
		setOverlayVisible: (state, action) => {
			state.overlayVisible = action.payload;
		},
		setOverlayType: (state, action) => {
			state.overlayType = action.payload;
		},
		setOverlayTransferData: (state, action) => {
			state.overlayTransferData = action.payload;
		},
		setOverlayTaxesData: (state, action) => {
			state.overlayTaxesData = action.payload;
		},
	},
});

export const {
	setActiveBankState,
	setOverlayVisible,
	setOverlayType,
	setOverlayTransferData,
	setOverlayTaxesData,
} = bankSlice.actions;

export default bankSlice.reducer;
